import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';
import TimesheetEntry from 'main/stores/time_tracking/TimesheetEntry';
import TimeTrackingPayPeriod from 'main/stores/time_tracking/TimeTrackingPayPeriod';
import TimeTrackingDimension from 'main/stores/time_tracking/TimeTrackingDimension';
import _ from 'lodash';
import Absence from 'main/stores/time_off/Absence';
import Holiday from 'main/stores/holidays/Holiday';

class Timesheet extends DomainObject {
  entries = [];
  absences = [];
  holidays = [];
  dimensions = [];
  totals = {};
  approved = false;
  canCreateEntries;
  manuallyEnterHours;
  canApprove;
  timeClockEnabled;
  collectEmployeeLocation;
  geofencingEnabled;

  _relations = {
    employee: Employee,
    entries: [TimesheetEntry],
    absences: [Absence],
    holidays: [Holiday],
    dimensions: [TimeTrackingDimension],
    payPeriod: TimeTrackingPayPeriod
  };

  constructor(other) {
    super();

    makeObservable(this, {
      entries: observable,
      absences: observable,
      holidays: observable,
      dimensions: observable,
      totals: observable,
      approved: observable,
      canCreateEntries: observable,
      manuallyEnterHours: observable,
      canApprove: observable,
      timeClockEnabled: observable,
      collectEmployeeLocation: observable,
      geofencingEnabled: observable,
      totalHours: computed
    });

    this.merge(other);
  }

  get totalHours() {
    return Math.round(_.sumBy(this.entries, 'hours') * 100) / 100;
  }
}

export default Timesheet;
